// Validation helper functions for Registration Form
export const areAllInputsFilled = (formState, currentStep) => {
    if (currentStep === 1) {
        return (
            formState.name?.trim() !== "" &&
            formState.surname?.trim() !== "" &&
            formState.phone?.trim() !== "" &&
            formState.email?.trim() !== "" &&
            formState.password?.trim() !== "" &&
            formState.passwordRetry?.trim() !== ""
        );
    }
    if (currentStep === 2) {
        // Only require address and city fields for step 2
        if (!formState.address || formState.address.trim() === "") return false;
        if (!formState.city || !formState.city.name || formState.city.name.trim() === "") return false;
        return true;
    }
    return false;
};


const validations = {
    areAllInputsFilled,
    isButtonDisabled: (formState, currentStep, privacyPolicy = true, termsAgreed = true) => {
        if (currentStep === 1) {
            return !(
                formState.name?.trim() !== "" &&
                formState.surname?.trim() !== "" &&
                formState.phone?.trim() !== "" &&
                formState.email?.trim() !== "" &&
                formState.password?.trim() !== "" &&
                formState.passwordRetry?.trim() !== "" &&
                formState.password === formState.passwordRetry &&
                privacyPolicy &&
                termsAgreed
            );
        } else if (currentStep === 2) {
            return !areAllInputsFilled(formState, currentStep);
        }
        return true;
    },

    /**
     * Validates passwords match
     * @param {string} password - Password value
     * @param {string} confirmPassword - Confirm password value
     * @returns {boolean} - Returns true if passwords match
     */
    doPasswordsMatch: (password, confirmPassword) => {
        return password === confirmPassword && password.trim() !== "";
    },

    /**
     * Validates email format
     * @param {string} email - Email to validate
     * @returns {boolean} - Returns true if email is valid
     */
    isValidEmail: (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    },


    /**
     * Get validation error messages for all form fields
     * @param {Object} formState - The current form state
     * @param {number} currentStep - Current registration step
     * @returns {Object} - Object containing error states for each field
     */
    getValidationErrors: (formState, currentStep) => {
        const errors = {};

        // Step 1 validations
        if (currentStep === 1) {
            if (!formState.name || formState.name?.trim() === "") {
                errors.name = "İsim alanı boş geçilemez";
            }

            if (!formState.surname || formState.surname?.trim() === "") {
                errors.surname = "Soyadı alanı boş geçilemez";
            }

            if (!formState.phone || formState.phone?.trim() === "") {
                errors.phone = "Telefon numarası boş geçilemez";
            }

            if (!formState.email || formState.email?.trim() === "") {
                errors.email = "E-posta alanı boş geçilemez";
            } else if (!validations.isValidEmail(formState.email)) {
                errors.email = "Geçerli bir e-posta adresi giriniz";
            }

            if (!formState.password || formState.password?.trim() === "") {
                errors.password = "Şifre alanı boş geçilemez";
            } else if (formState.password.length < 6) {
                errors.password = "Şifre en az 6 karakter olmalıdır";
            }

            if (!formState.passwordRetry || formState.passwordRetry?.trim() === "") {
                errors.passwordRetry = "Şifre tekrarı alanı boş geçilemez";
            } else if (formState.password !== formState.passwordRetry) {
                errors.passwordRetry = "Şifreler eşleşmiyor";
            }
        }

        // Step 2 validations
        if (currentStep === 2) {
            // Remove birthdate, birthPlace, motherName, fatherName, gender, postalCode validations
            if (formState.address?.trim() === "") {
                errors.address = "Adres boş geçilemez";
            }

            if (formState.country?.name?.trim() === "") {
                errors.country = "Ülke seçiniz";
            }

            if (formState.city?.name?.trim() === "") {
                errors.city = "Şehir seçiniz";
            }
        }

        return errors;
    }
};

export default validations;
